import React, { useEffect } from 'react'
import { Button, Modal } from '@imedcl/design-system'
import { ReactComponent as Imagedisconnected } from '../../assets/img/disconnected_medpay.svg'
import { useNavigate } from 'react-router-dom'
import { decode } from 'string-encode-decode'

export default function ModalContent() {
  const navigate = useNavigate()

  useEffect(() => {
    let sessionActive = localStorage.getItem('session')
    if (!sessionActive) {
      navigate('/')
    }
  })

  const volver = () => {
    const document = decode(sessionStorage.getItem('documentos'))
    const selectItems = decode(sessionStorage.getItem('selectItems'))
    const countDocument = JSON.parse(document).length
    const json = {
      status: 200,
      cantidad: countDocument,
      documentos: JSON.parse(document),
      selectedRows: JSON.parse(selectItems),
    }
    navigate('/listDebts', { state: json })
  }
  return (
    <div className='mt-8'>
      <Modal backgroundClassName='!relative'>
        <React.Fragment key='.0'>
          <div className='mb-6  flex items-center justify-center '>
            <Imagedisconnected></Imagedisconnected>
          </div>
          <div>
            <h1 className='text-center font-bold text-2xl text-secondary-imed-100 mb-4'>
              Conexión fallida
            </h1>
          </div>
          <div>
            <h2 className='text-center tracking-tight text-xl text-secondary-imed-100 mb-4'>
              ¡Discúlpanos! En este momento no es<br></br>
              posible conectar con Medpay.<br></br>
              Por favor vuelve a intentarlo
            </h2>
          </div>
          <div className='flex items-center justify-center'>
            <Button className='m-4' type='secondary' onClick={volver}>
              Intentar nuevamente
            </Button>
          </div>
        </React.Fragment>
      </Modal>
    </div>
  )
}
